import React, { BaseHTMLAttributes } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { parse } from 'tldts';

interface LogoProps extends Pick<BaseHTMLAttributes<HTMLSpanElement>, 'className'> {
  url?: string | null;
  shortName?: string | null; 
  longName?: string | null;
}

const Logo: React.FC<LogoProps> = ({ url, shortName, longName, className }) => {
  return (
    <Avatar className={className}>
      {url && typeof url === 'string' ? (
        <AvatarImage src={`https://img.logo.dev/${encodeURIComponent(parse(url)?.domain || 'https://wise.com')}?token=pk_anODdxLxQaKfOQUB_Apljg`} />
      ) : null}
      <AvatarFallback>
        {shortName && shortName?.split(' ').map((word: string) => word.slice(0, 2)).join('') || 
         longName && longName?.split(' ').map(word => word.slice(0, 2)).join('') || 
         'N/A'}
      </AvatarFallback>
    </Avatar>
  );
};

export { Logo };
